/**
 * New-build prompt. A tab can stay open for days, running a bundle that a
 * later deploy has replaced. Every deploy writes `/version.txt`
 * ("<version> <target>") next to the bundle, so the page compares its own
 * baked-in version against the file its own site serves right now. That makes
 * the check correct per tenant: a tenant whose deploy failed keeps serving the
 * old file and never shows the prompt.
 *
 * This file is identical in frontend, admin-portal and superadmin-portal.
 */

export const BUILD_VERSION_PATH = '/version.txt';

// Owner decision 2026-09-29: check every 30 minutes.
export const BUILD_CHECK_INTERVAL_MS = 30 * 60 * 1000;

// A tab coming back into view also checks (a laptop that slept overnight should
// not wait up to 30 minutes), but rapid tab switching must not hammer the host.
export const BUILD_CHECK_MIN_GAP_MS = 60 * 1000;

export const BUILD_CHECK_TIMEOUT_MS = 10 * 1000;

export const BUILD_UPDATE_COPY = {
  message: 'There is a new update available.',
  action: 'Refresh',
} as const;
